import {
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import IconUser from "../../../components/IconUser";
import { ReactComponent as IconBusiness } from "../../../images/iconBusiness.svg";
import { ReactComponent as IconContent } from "../../../images/iconContent.svg";

import "../../PrimeiraConsulta/modulos/styles.css";

const colors = {
  Neurologia: "#A254DF",
  Nutrição: "#65C94D",
  Psicologia: "#7AABC5",
  Fonoaudiologia: "#D85050",
  Fisioterapia: "#FE9647",
};

const styles = {
  button: {
    textTransform: "none",
    borderRadius: "5px",
    height: "30px",
    fontSize: "16px",
    fontWeight: "500",
    LineHeight: "22px",
    minWidth: "176px",
    width: "176px",
  },
  title: {
    fontSize: "16px",
    fontWeight: "600",
    LineHeight: "22px",
  },
};

export default function AccordionItem({
  AccordionTitle = "Neurologia",
  title = "",
  text = "",
  escalasPaciente = true,
  funcMonitorEvolution = () => {},
  funRegisterScale = () => {},
}) {
  return (
    <Stack
      sx={{
        display: "flex",
        gap: "20px 32px",
        flexDirection: "row",
        flexWrap: "wrap",
      }}
    >
      <Stack width="80px" height="80px">
        <IconUser bgColor={colors[AccordionTitle]} />
      </Stack>
      <Stack
        sx={{
          flex: 1,
          minWidth: "360px",
          marginTop: "15px",
        }}
      >
        <Accordion
          defaultExpanded={false}
          className="AccordionContainer"
          sx={{
            boxShadow: "none !important",
            border: "1px solid #CCCCCC",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMore style={{ color: "#1E729F" }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            className="AccordionSummaryContainer"
            sx={{
              height: "50px",
            }}
          >
            <Typography className="Accordion_title colorBlueDark">
              {AccordionTitle}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "16px",
                flexWrap: "wrap",
                marginBottom: "10px",
              }}
            >
              <Typography style={styles.title} className="colorBlueDark">
                {title}
              </Typography>
              <Stack
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "16px",
                  flexWrap: "wrap",
                }}
              >
                {escalasPaciente && (<Button
                  variant="outlined"
                  sx={{
                    ...styles.button,
                    border: "1px solid #1E729F",
                    color: "#1E729F",
                  }}
                  startIcon={<IconBusiness width="24px" height="24px" />}
                  onClick={funcMonitorEvolution}
                >
                  Ver evolução
                </Button>)}
                <Button
                  variant="contained"
                  sx={{
                    ...styles.button,
                    color: "#fff",
                    backgroundColor: "#1E729F",
                  }}
                  startIcon={<IconContent width="24px" height="24px" />}
                  onClick={funRegisterScale}
                >
                  Registrar escala
                </Button>
              </Stack>
            </Stack>
            <Typography
              sx={{ ...styles.title, fontWeight: "500", color: "#737373" }}
            >
              {text}
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Stack>
    </Stack>
  );
}
